import React, { useState } from "react"
import {
  Container,
  Card,
  CardBody,
  Input,
  Button,
  Badge,
  CardImg,
  Alert,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from "reactstrap"
import { useLocation } from "react-router-dom"
import { toast, ToastContainer } from "react-toastify"
import axios from "axios"
import moment from "moment/moment"

import { replaceS3Url } from "components/Common/ReplaceS3Url"
import Spinners from "components/Common/Spinner"

const MyModal = ({ modal, value, toggle }) => {
  const currentAttachment = value

  const downloadAttachment = () => {
    const a = document.createElement("a")
    a.href = currentAttachment
    a.download = currentAttachment.split("/").pop()
    a.click()
  }

  const isImage = /\.(jpeg|jpg|png|gif|webp)$/i.test(currentAttachment)
  const isPdf = /\.pdf$/i.test(currentAttachment)

  return (
    <Modal isOpen={modal} toggle={toggle}>
      <ModalHeader toggle={toggle}>Assignment</ModalHeader>
      <ModalBody>
        {currentAttachment ? (
          <div className="mb-4">
            {/* <p><strong>Attachment</strong></p> */}

            {isImage ? (
              <img
                src={encodeURI(currentAttachment)}
                alt="attachment"
                style={{
                  maxWidth: "100%",
                  maxHeight: "400px",
                  borderRadius: "8px",
                }}
                className="mb-2"
              />
            ) : isPdf ? (
              <a
                href={currentAttachment}
                target="_blank"
                rel="noopener noreferrer"
              >
                <CardImg
                  top
                  src="https://cdn-icons-png.flaticon.com/512/337/337946.png"
                  alt="PDF Icon"
                  style={{ width: "40px", height: "40px" }}
                />
              </a>
            ) : (
              <span className="text-sm text-gray-600">
                (Preview not available for this file type)
              </span>
            )}
          </div>
        ) : (
          <p>No attachment available.</p>
        )}
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={toggle}>
          Close
        </Button>
        {currentAttachment && (
          <Button color="primary" onClick={downloadAttachment}>
            Download
          </Button>
        )}
      </ModalFooter>
    </Modal>
  )
}

const Details1 = ({ title, value }) => {
  const [modal, setModal] = useState(false)
  const toggle = () => {
    setModal(!modal)
  }
  return (
    <div className="d-flex flex-row justify-content-between align-items-center mb-3">
      <span className="text-dark fw-bold w-50">{title}:</span>
      <Badge
        color="primary"
        className="w-50 px-3 py-2 rounded-4 text-white"
        onClick={toggle}
      >
        View
      </Badge>

      {modal ? <MyModal modal={modal} value={value} toggle={toggle} /> : null}
    </div>
  )
}

const Details = ({ title, value }) => {
  return (
    <div className="d-flex flex-row justify-content-between align-items-center mb-3">
      <span className="text-dark fw-bold w-50">{title}:</span>
      <span className="text-dark w-50 text-break">{value}</span>
    </div>
  )
}

const Submit = () => {
  const token = JSON.parse(localStorage.getItem("Token"))

  const [isSubmit, setSubmit] = useState(false)
  const live_url = ""
  const location = useLocation()
  const [error, setError] = useState(false)
  const [file, setFile] = useState([])
  const [Loading, setLoading] = useState(false)

  const handleSubmitAssignment = async e => {
    e.preventDefault()
    setSubmit(false)
    try {
      if (!file) {
        setError(true)
        return
      }

      setError(false)
      setLoading(true)
      const fm = new FormData()
      fm.append("assignmentId", location.state.id)
      file.forEach(f => {
        fm.append("files", f)
      })
      await axios({
        method: "POST",
        url: "https://marcopolo.prisms.in/api/assignment/submit-assignment",
        data: fm,
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: token,
        },
      }).then(res => {
        toast.success(res.data.message)
        setLoading(false)
        setSubmit(true)
      })
    } catch (error) {
      console.error("Error submitting assignment:", error)
      setSubmit(false)
      toast.error("Something went wrong. Please try again.")
    }
  }

  console.log(location.state.submitted_assign)

  return (
    <div className="page-content px-0 bg-white" style={{ paddingTop: "90px" }}>
      <Container>
        <Card className="shadow-lg border-0 rounded-lg p-2">
          {Loading ? (
            <Spinners />
          ) : (
            <CardBody className="p-2">
              <Details title="Subject" value={location.state.subject} />
              <Details
                title="Date"
                value={moment(location.state.date).format("DD-MM-YYYY")}
              />
              <Details title="description" value={location.state.description} />
              <Details title="Teacher Name" value={location.state.staff_name} />
              <Details title="Teacher Remarks" value={location.state.remarks} />

              <Details1
                title="Assignment"
                value={replaceS3Url(location.state.file_location)}
              />
              {(!location.state.remarks ||
                location.state.remarks.trim() === "") &&  (!location.state.submitted_assign ||
                  location.state.submitted_assign !== "null" ||
              (Array.isArray(location.state.submitted_assign) &&
              location.state.submitted_assign.length == 0)) ? (
                <div className="mt-4">
                  {isSubmit !== true ? (
                    <Alert color="info">You can upload 6 Attachments</Alert>
                  ) : null}

                  {isSubmit !== true ? (
                    <Input
                      id="fileUpload"
                      type="file"
                      className="form-control mb-4"
                      multiple
                      onChange={e => {
                        const selectedFiles = Array.from(e.target.files)

                        if (selectedFiles.length > 6) {
                          setError("You can only upload up to 6 files.")
                          setFile([])
                        } else {
                          setError("")
                          setFile(selectedFiles)
                        }
                      }}
                    />
                  ) : null}
                </div>
              ) : null}
              {error ? (
                <Alert color="danger">Attachments are required</Alert>
              ) : null}

              {file.length > 0 && (
                <ul className="mt-2 space-y-2 list-unstyled">
                  {file.map((f, index) => {
                    const isImage = /\.(jpg|jpeg|png|gif|webp)$/i.test(f.name)
                    const isPdf = /\.pdf$/i.test(f.name)

                    return (
                      <li
                        key={index}
                        className="flex flex-column items-center space-x-2"
                      >
                        {isImage ? (
                          <img
                            src={URL.createObjectURL(f)}
                            alt={f.name}
                            className="mt-2 p-2"
                            style={{
                              width: "100px",
                              height: "100px",
                              objectFit: "cover",
                              borderRadius: "2px",
                            }}
                          />
                        ) : isPdf ? (
                          <img
                            className="mt-2 p-2"
                            src="https://cdn-icons-png.flaticon.com/512/337/337946.png"
                            alt="PDF Icon"
                            style={{ width: "40px", height: "40px" }}
                          />
                        ) : (
                          <span className="text-sm text-gray-600">
                            Unknown File Type
                          </span>
                        )}
                        <span className="text-sm break-all">{f.name}</span>
                      </li>
                    )
                  })}
                </ul>
              )}

              {Array.isArray(location.state.submitted_assign) &&
                location.state.submitted_assign.length > 0 && (
                  <div className="grid grid-cols-2 gap-4 mt-2">
                    {location.state.submitted_assign.map((url, index) => {
                      if (!url) return null
                      const fileUrl = decodeURIComponent(url.trim())
                      const fileName =
                        fileUrl.split("/").pop() || `File-${index + 1}`
                      const isImage = /\.(jpg|jpeg|png|gif|webp)$/i.test(
                        fileUrl
                      )
                      const isPdf = /\.pdf$/i.test(fileUrl)

                      return (
                        <div
                          key={index}
                          className="grid grid-cols-2 gap-4 mt-2"
                        >
                          {isImage ? (
                            <CardImg
                              top
                              src={encodeURI(url)}
                              alt={fileName}
                              style={{
                                width: "100%",
                                height: "150px",
                                objectFit: "cover",
                                borderRadius: "8px",
                              }}
                            />
                          ) : isPdf ? (
                            <CardImg
                              top
                              src="https://cdn-icons-png.flaticon.com/512/337/337946.png"
                              alt="PDF Icon"
                              style={{
                                width: "60px",
                                height: "60px",
                                marginBottom: "8px",
                              }}
                            />
                          ) : (
                            <span className="text-sm text-muted">
                              Unsupported file
                            </span>
                          )}
                          {/* <span className="text-sm break-all">{fileName}</span> */}
                        </div>
                      )
                    })}
                  </div>
                )}

              {isSubmit !== true &&
                (!location.state.remarks ||
                  location.state.remarks.trim() === "") &&
                (!location.state.submitted_assign ||
                  location.state.submitted_assign !== "null" ||
                  (Array.isArray(location.state.submitted_assign) &&
                    location.state.submitted_assign.length === 0)) && (
                  <div className="text-center mt-1">
                    <Button
                      color="primary"
                      className="px-4 py-2"
                      onClick={handleSubmitAssignment}
                    >
                      Submit
                    </Button>
                  </div>
                )}
            </CardBody>
          )}
        </Card>
        <ToastContainer />
      </Container>
    </div>
  )
}

export default Submit
